import { useFormik } from "formik";
import React, { useEffect } from "react";
import PageWithCard from "../../components/infrastructure/PageWithCard";
import FormikSelectGroup from "../../components/formik/FormikSelectGroup";
import { ClipLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import PrimaryButton from "../../components/infrastructure/Buttons/PrimaryButton";
import { fetchUsers, getUsers } from "../../app/reducers/Users/userSlice";
import { useNavigate } from "react-router-dom";
import { generateOptions } from "../../utils/Utils";
import {
  fetchLocations,
  getLocation,
} from "../../app/reducers/Location/locationSlice";
import {
  fetchSendJobWorksOrders,
  getJobWorkPO,
  setEditId,
  reset,
} from "../../app/reducers/SendJobWork/SendJobWork";
import { Edit2, Eye, Trash } from "react-feather";
import TableWithHeadingAndGlobalSearch from "../../components/Table/TableWithHeadingAndGlobalSearch";
import { useCallback } from "react";
import { useMemo } from "react";
import { useState } from "react";
import FormikMultiSelect from "../../components/formik/FormikMultiSelect";
import PaginationClassic from "../../components/pagination/PaginationClassic";
import ViewJobPanel from "./ViewJobPanel";
import moment from "moment";
import FormikInputDateGroup from "../../components/formik/FormikInputDateGroup";

const ViewJobWork = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [viewPurchaseModel, setViewPurchaseModalOpen] = useState(false);
  const [viewingParty, setViewingParty] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    dispatch(reset({}));
  }, []);

  useEffect(() => {
    dispatch(fetchUsers({ role: "job_work" }));
    dispatch(fetchLocations());
  }, []);

  const { users } = useSelector(getUsers);
  const { location } = useSelector(getLocation);
  const { jobWorkPO, loading: jobWorkPoLoading } = useSelector(getJobWorkPO);

  const handleSettled = async (rowData) => {
    let data = {
      _id: rowData._id,
      status: "settled",
    };
    await dispatch(updateStatusGreyPurchaseOrder(data));
    dispatch(
      fetchGreyPurchaseOrders({
        manufacturer: rowData.manufacturer,
        location: rowData.location,
        status: rowData.status,
        populate: true,
      })
    );
  };

  const columns = [
    {
      Header: "SRNO",
      Cell: (prop) => {
        const { data, row } = prop;
        return row.index + jobWorkPO.pagingCounter;
      },
    },
    {
      Header: "Date",
      Cell: ({ row }) => {
        return moment(row.original.createdAt).format("DD/MM/YYYY HH:mm");
      },
    },
    {
      Header: "Catalog",
      accessor: "catalogData.name",
    },
    {
      Header: "Colour",
      accessor: "productData.color",
    },
    {
      Header: "Job Work User",
      accessor: "manufacturerData.name",
    },
    {
      Header: "Job Work",
      accessor: "jobWorkName",
    },
    {
      Header: "Location",
      accessor: "locationData.name",
    },
    {
      Header: "Price",
      accessor: "price",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Ordered Total",
      accessor: "quantity",
    },
    {
      Header: "Ordered Remaining",
      accessor: "remaining",
    },
    {
      Header: "Action",
      Cell: (prop) => {
        const { data, row } = prop;
        return (
          <div
            className="flex items-center gap-2"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Eye
              size={18}
              color="green"
              onClick={() => {
                setViewPurchaseModalOpen(true);
                setViewingParty(row.original);
              }}
            />
          </div>
        );
      },
    },
  ];

  const locationdata = useMemo(
    () => (location?.docs ? location.docs : []),
    [location]
  );

  const data = useMemo(
    () => (jobWorkPO?.docs ? jobWorkPO.docs : []),
    [jobWorkPO]
  );
  // console.log(data,"dekhtehai")

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      location: [],
      status: [],
      manufacturer: [],
      from : null,
      to : null,
    },
    validationSchema: Yup.object({
      location: Yup.array().required(),
      status: Yup.array().required(),
      manufacturer: Yup.array().required(),
    }),
    onSubmit: async (values, { resetForm }) => {
      console.log(values, "checking");
      try {
        getJobWorksData(values)
      } catch (error) {
        console.log('Error',error)
      }
      // dispatch(
      //   fetchSendJobWorksOrders({
      //     ...values,
      //     status: { $in: values.status },
      //     populate: true,
      //     page,
      //     limit: 2,
      //   })
      // );
    },
  });

  const getJobWorksData = (values,search=null)=>{
    let payload = {
      populate : true,
      page,
      search,
    }
    if(values.location.length){
      payload['locationData._id'] = { $in : values.location}
    }
    if(values.manufacturer.length){
      payload['manufacturerData._id'] = { $in : values.manufacturer}
    }
    if(values.status.length){
      payload['status'] = { $in : values.status}
    }
    if(values.from && values.to){
      payload['createdAt'] = { 
        $gte : moment(values.from).startOf('day').valueOf(),
        $lt : moment(values.to).endOf('day').valueOf(),
      }
    }

    dispatch(fetchSendJobWorksOrders(payload))
  }

  useEffect(() => {
    // let data = {};
    // if (formik.values.location) {
    //   data["location"] = formik.values.location;
    // }
    // if (formik.values.manufacturer) {
    //   data["manufacturer"] = formik.values.manufacturer;
    // }
    // dispatch(
    //   fetchSendJobWorksOrders({
    //     ...data,
    //     status: { $in: formik.values.status },
    //     populate: true,
    //     page,
    //   })
    // );
    getJobWorksData(formik?.values)
  }, [page]);

  const debouncedSearch = useCallback(
    _.debounce((search, values) => {
      getJobWorksData(values, search)
      // dispatch(
      //   fetchSendJobWorksOrders({
      //     ...values,
      //     status: { $in: values.status },
      //     search: search,
      //     populate: true,
      //   })
      // );
    }, 300),
    []
  );

  return (
    <>
      <ViewJobPanel
        open={viewPurchaseModel}
        setOpen={setViewPurchaseModalOpen}
        party={viewingParty}
      />
      <div className="p-4">
        <div className="mb-4">
          <h1 className="text-2xl md:text-3xl text-slate-800 font-bold">
            View Job Work Orders
          </h1>
        </div>
        {/* {loading ? (
        <ClipLoader />
      ) : ( */}
        <form onSubmit={formik.handleSubmit} className="flex flex-col gap-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormikMultiSelect
              formik={formik}
              label="Manufacturer"
              name="manufacturer"
              options={generateOptions({
                array: users ? users.docs : [],
                valueField: "_id",
                labelField: "name",
              })}
              required
            />
            <FormikMultiSelect
              formik={formik}
              label="Location"
              name="location"
              required
              options={generateOptions({
                array: locationdata,
                valueField: "_id",
                labelField: "name",
              })}
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormikMultiSelect
              formik={formik}
              label="Status"
              name="status"
              required
              options={generateOptions({
                array: [
                  { label: "Pending", value: "pending" },
                  { label: "Completed", value: "completed" },
                  { label: "Settled", value: "settled" },
                  { label: "Incomplete", value: "incomplete" },
                ],
                valueField: "value",
                labelField: "label",
              })}
            />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <FormikInputDateGroup 
                formik={formik}
                label="Created From"
                name='from'
              />
              <FormikInputDateGroup 
                formik={formik}
                label="Created to"
                name='to'
              />
            </div>
          </div>
          <div>
            <PrimaryButton type="submit">Submit</PrimaryButton>
          </div>
        </form>
        {/* // )} */}
        {/* <EditGreyModal /> */}
        <div className="mt-4">
          <TableWithHeadingAndGlobalSearch
            heading="Job Work Orders"
            data={data}
            columns={columns}
            loading={jobWorkPoLoading}
            searchFunction={(value) => {
              debouncedSearch(value, formik.values);
            }}
          />
          <PaginationClassic paginationDetails={jobWorkPO} setPage={setPage} />
        </div>
      </div>
    </>
  );
};

export default ViewJobWork;
